import type { FC } from 'react';

interface BundledExternalStyleProps {
  id?: string;

  href: string;
  /**
   * Optional CSS Cascade layer name to wrap the style in
   */
  layer?: string;
  /**
   * Optional tag to add to the style for debugability to see where on the backend the style is coming from
   */
  cysOrigin?: string;
}

/**
 * This component fetches external styles SYNCRONOUSLY (blocking render, so no layout shift)
 * and bundles them in an inline style
 *
 * This allows us to easily wrap external styles in a CSS layer as well as bundle and optimize them using NextJS SSR
 * This component will work on the client and on the server
 */
export const BundledExternalStyle: FC<BundledExternalStyleProps> = (
  props: BundledExternalStyleProps
) => {
  return (
    <style
      id={props.id}
      data-cysorigin={props.cysOrigin}
      dangerouslySetInnerHTML={{
        __html: `@import url('${props.href}') layer(${props.layer});`,
      }}
    />
  );
};
